var map = {
	"./access_alarm.svg": "ff48",
	"./access_alarms.svg": "49f8",
	"./access_time.svg": "dc10",
	"./add_alarm.svg": "d41f",
	"./airplanemode_active.svg": "eaa9",
	"./airplanemode_inactive.svg": "8118",
	"./battery_20.svg": "31a2",
	"./battery_30.svg": "403a",
	"./battery_50.svg": "7e8a",
	"./battery_60.svg": "e2b2",
	"./battery_80.svg": "41e9",
	"./battery_90.svg": "784f",
	"./battery_alert.svg": "c499",
	"./battery_charging_20.svg": "4d88",
	"./battery_charging_30.svg": "1113",
	"./battery_charging_50.svg": "25f9",
	"./battery_charging_60.svg": "5148",
	"./battery_charging_80.svg": "98b5",
	"./battery_charging_90.svg": "dfef",
	"./battery_charging_full.svg": "b12c",
	"./battery_full.svg": "c3ba",
	"./battery_std.svg": "e3bb",
	"./battery_unknown.svg": "4f90",
	"./bluetooth.svg": "e12e",
	"./bluetooth_connected.svg": "c48b",
	"./bluetooth_disabled.svg": "762a",
	"./bluetooth_searching.svg": "d4eb",
	"./brightness_auto.svg": "c458",
	"./brightness_high.svg": "7042",
	"./brightness_low.svg": "2431",
	"./brightness_medium.svg": "fce0",
	"./data_usage.svg": "7c43",
	"./developer_mode.svg": "14f2",
	"./devices.svg": "9947",
	"./dvr.svg": "238b",
	"./gps_fixed.svg": "bd31",
	"./gps_not_fixed.svg": "68e8",
	"./gps_off.svg": "7a26",
	"./graphic_eq.svg": "1336",
	"./location_disabled.svg": "1e33",
	"./location_searching.svg": "efab",
	"./network_cell.svg": "0c7d",
	"./network_wifi.svg": "53cc",
	"./nfc.svg": "414a",
	"./screen_lock_landscape.svg": "e307",
	"./screen_lock_portrait.svg": "29db",
	"./screen_lock_rotation.svg": "1684",
	"./screen_rotation.svg": "06bf",
	"./sd_storage.svg": "b553",
	"./settings_system_daydream.svg": "0ccb",
	"./signal_cellular_0_bar.svg": "a5af",
	"./signal_cellular_1_bar.svg": "5248",
	"./signal_cellular_2_bar.svg": "fcf6",
	"./signal_cellular_3_bar.svg": "ffd1",
	"./signal_cellular_4_bar.svg": "2b0e",
	"./signal_cellular_connected_no_internet_0_bar.svg": "7553",
	"./signal_cellular_connected_no_internet_1_bar.svg": "cbf8",
	"./signal_cellular_connected_no_internet_2_bar.svg": "fc82",
	"./signal_cellular_connected_no_internet_3_bar.svg": "8df7",
	"./signal_cellular_connected_no_internet_4_bar.svg": "19eb",
	"./signal_cellular_no_sim.svg": "18e4",
	"./signal_cellular_null.svg": "ea86",
	"./signal_cellular_off.svg": "8c18",
	"./signal_wifi_0_bar.svg": "ad04",
	"./signal_wifi_1_bar.svg": "f4c2",
	"./signal_wifi_1_bar_lock.svg": "f654",
	"./signal_wifi_2_bar.svg": "4d47",
	"./signal_wifi_2_bar_lock.svg": "712b",
	"./signal_wifi_3_bar.svg": "82f0",
	"./signal_wifi_3_bar_lock.svg": "81db",
	"./signal_wifi_4_bar.svg": "c5d5",
	"./signal_wifi_4_bar_lock.svg": "5cda",
	"./signal_wifi_off.svg": "8424",
	"./signal_wifi_statusbar_1_bar_26x24px.svg": "c97f",
	"./signal_wifi_statusbar_2_bar_26x24px.svg": "e625",
	"./signal_wifi_statusbar_3_bar_26x24px.svg": "d87a",
	"./signal_wifi_statusbar_4_bar_26x24px.svg": "81fa",
	"./signal_wifi_statusbar_connected_no_internet_1_26x24px.svg": "6bf4",
	"./signal_wifi_statusbar_connected_no_internet_26x24px.svg": "0492",
	"./signal_wifi_statusbar_connected_no_internet_2_26x24px.svg": "1511",
	"./signal_wifi_statusbar_connected_no_internet_3_26x24px.svg": "d429",
	"./signal_wifi_statusbar_connected_no_internet_4_26x24px.svg": "acff",
	"./signal_wifi_statusbar_not_connected_26x24px.svg": "5d33",
	"./signal_wifi_statusbar_null_26x24px.svg": "5293",
	"./storage.svg": "95c2",
	"./usb.svg": "8c08",
	"./wallpaper.svg": "1285",
	"./widgets.svg": "f35a",
	"./wifi_lock.svg": "c542",
	"./wifi_tethering.svg": "9616"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ad41";